import moment from "moment";
import { updateSession } from "../../../slices/sessions/updateSession/thunk";
import { terminateSession } from "../../../slices/sessions/terminateSession/thunk";

export const updateTerminateSessionApiCall = (value,dispatch,setLoading,customerId,setUpdateSession,isView,sessionInfo,terminateSessions,setButtonInitiateSession) => {
    const jsonObj = JSON.stringify({
        "eventType":!terminateSessions? "Updated":"Ended",
        "timestamp": moment(value?.sessionTime).format('YYYY-MM-DDTHH:mm:ss[Z]'),
        "sessionId": `TEST-SESSION-${value.sessionId}`, 
        "subscriptionId":sessionInfo?.subscriptionId,
        "seqno": sessionInfo?.sequenceNumber,
        ...(terminateSessions === false && {
            requestedServiceUnit: parseFloat(value?.requestedUnits),
        }),
        ...((terminateSessions === true || value?.usedUnits!='') && {
            usedServiceUnit: parseFloat(value?.usedUnits),
        }),
        "uom": sessionInfo?.uom ,
        "usageEventType": sessionInfo?.usageEventType,
        ...(value?.attributes && value.attributes.length > 0 ? {
            "attributes": value.attributes.map(attr => ({
                "attributeName": attr.name?.value || attr.name,
                "attributeValue": attr.value
            }))
        } : {})

    })
if(!terminateSessions){
    dispatch(updateSession(jsonObj,setLoading,customerId,sessionInfo?.subscriptionId,setUpdateSession,setButtonInitiateSession))
}else{
    dispatch(terminateSession(jsonObj, setLoading,customerId,sessionInfo?.subscriptionId,setUpdateSession,setButtonInitiateSession))
}
   
}